<template>
  <div>
    <div class="dict">
      <h1>数据字典</h1>
      <button type="button" class="ivu-btn ivu-btn-primary ivu-btn-large" @click="medal=true;id=-1">
        <i class="ivu-icon ivu-icon-android-add"></i>
        <span>添加</span>
      </button>
      <ul v-for="(item,index) in list" class="ivu-menu-vertical ivu-menu-submenu" :class="{'ivu-menu-opened':item.isshow}" style="max-height: 435px;overflow-y: auto;">
        <div class="parent" @click="get_detail(item.type,index)">
          {{item.type}}
          <i class="ivu-icon ivu-icon-ios-arrow-down ivu-menu-submenu-title-icon" style="top: 9px;right: 10px;cursor: pointer;"></i>
        </div>
        <li v-show="item.isshow" v-for="(re,inc) in item.child" class="ivu-menu-vertical ivu-menu-submenu" :class="{'ivu-menu-opened1':re.ishow}">
          <div @click="change_arro(index,inc)">
          {{re.itemName}}
          <i class="ivu-icon ivu-icon-ios-arrow-down ivu-menu-submenu-title-icon1" style="top: 9px;right: 10px;cursor: pointer;" v-if="re.child"></i>
          <div class="child" @click="dele(re.id)">删除</div>
          <div class="child" @click="edit(re.id)" style="background-color: #57a3f3; border-color: #57a3f3">编辑</div>
          <div class="child" @click="add_child(re,index)" style="background-color: #57a3f3; border-color: #57a3f3">添加下级</div>
          <div v-if="re.ishow">
            <li v-for="re_c in re.child">
              {{re_c.itemName}}
              <div class="child" @click="dele(re_c.id)">删除</div>
              <div class="child" @click="edit(re_c.id)" style="background-color: #57a3f3; border-color: #57a3f3">编辑</div>
              <div class="child" @click="add_child(re_c,index)" style="background-color: #57a3f3; border-color: #57a3f3">添加下级</div>
            </li>
          </div>
          </div>
        </li>
        <li v-show="item.isshow" style="background-color: #2d8cf0;text-align:center;color:white;border-radius: 0 0 5px 5px;border-top: 1px solid #2d8cf0;cursor: pointer;" @click="add_sam(item.type,index)">添加子数据</li>
      </ul>
      <creat-dict :medal="medal" @medal_ch="change_medal" :ed="id" :now_type="now_type" :parentId="parentId"></creat-dict>
    </div>
  </div>
</template>
<script>
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import { FieldType, Filter, CompareType } from "../../../store/entities/filter";
import PageRequest from "../../../store/entities/page-request";
import ajax from "../../../lib/ajax";
import axios from "axios";
import CreatDict from "./creat-dict.vue";
var Url = "http://qy.chinapsp.cn:8883";
export default {
  components: {
    CreatDict
  },
  data() {
    return {
      list: [], //字典列表
      medal: false,
      id: 0, //当前编辑数据id
      now_type: "", //当前类型
      now_index: '',//当前序列号
      parentId: '',
    }
  },
  async created() {
    this.getData();
  },
  methods: {
    async getData() {
      var that = this;
      await ajax
        .get("/api/services/app/AbpDataDict/GetAllDataType")
        .then(res => {
          res.data.result.items = res.data.result.items.map(item => {
            return { type: item, isshow: 0, child: [] };
          });
          that.list = res.data.result.items;
        });
    },
    async get_detail(type, index) {
      event.stopPropagation();
      if (this.list[index].isshow == 0) {
        await ajax
          .get(
            // "/api/services/app/AbpDataDict/GetPaged?filter=itemType%3D%3D%22" +
            // type +
            // "%22&maxResultCount=100&skipCount=0"
            `/api/services/app/AbpDataDict/GetList?filter=itemType=="${type}"`
          )
          .then(res => {
            var new_list = []
            res.data.result.items.forEach((element,ind) => {
              if(!element.itemParent){
                let which = new_list.length
                new_list[which] = element;
                new_list[which].ishow = 0
              }else{
                for(var i=0;i<new_list.length;i++){
                  if(element.itemParent==new_list[i].id){
                    if(!new_list[i].child){
                      new_list[i].child = []
                    }
                    new_list[i].child = [...new_list[i].child,element]
                  }
                }
              }
            });
            this.list[index].child = new_list;
            // this.list[index].child = res.data.result.items;
          });
      }
      this.list[index].isshow = (this.list[index].isshow + 1) % 2;
    },
    async change_medal(val) {
      this.parentId = ''
      //改变模态框的值
      this.medal = val;
      var self = this;
      if (val == 0 && this.id == -1) {
        await ajax
          .get("/api/services/app/AbpDataDict/GetAllDataType")
          .then(res => {
            res.data.result.items = res.data.result.items.map(item => {
              return { type: item, isshow: 0, child: [] };
            });
            this.list = res.data.result.items;
          });
      } else if (val == 0 && this.id == -2) {
        await ajax
          .get(
            // "/api/services/app/AbpDataDict/GetPaged?filter=itemType%3D%3D%22" +
            // self.now_type +
            // "%22&maxResultCount=100&skipCount=0"
            `/api/services/app/AbpDataDict/GetList?filter=itemType=="${self.now_type}"`
          )
          .then(res => {
            var new_list = []
            res.data.result.items.forEach((element,ind) => {
              if(!element.itemParent){
                let which = new_list.length
                new_list[which] = element;
                new_list[which].ishow = 1
              }else{
                for(var i=0;i<new_list.length;i++){
                  if(element.itemParent==new_list[i].id){
                    if(!new_list[i].child){
                      new_list[i].child = []
                    }
                    new_list[i].child = [...new_list[i].child,element]
                  }
                }
              }
            });
            this.list[self.now_index].child = new_list;
            //this.list[self.now_index].child = res.data.result.items;
          });
      }
    },
    dele(id) {
      event.stopPropagation();
      this.$Modal.confirm({
        title: "删除数据",
        content: "是否删除此数据",
        onOk: () => {
          ajax
            .delete("/api/services/app/AbpDataDict/Delete?id=" + id)
            .then(res => {
              if (res.data.success) {
                this.$Message.success("删除成功！");
                ajax
                  .get("/api/services/app/AbpDataDict/GetAllDataType")
                  .then(res => {
                    res.data.result.items = res.data.result.items.map(item => {
                      return { type: item, isshow: 0, child: [] };
                      //return { type: item, isshow: 1, child: [] };
                    });
                    this.list = res.data.result.items;
                  });
              } else {
                this.$Message.success("操作出错！");
                return;
              }
            });
        },
        onCancel: () => {
          this.$Message.info("Clicked cancel");
        }
      });
    },
    edit(id) {
      event.stopPropagation();
      this.medal = true;
      this.id = id;
    },
    add_sam(type, index) {
      event.stopPropagation();
      this.medal = true;
      this.id = -2;
      this.now_type = type
      this.now_index = index
    },
    add_child(item, index) {
      event.stopPropagation();
      this.medal = true
      this.id = -2
      this.now_type = item.itemType
      this.now_index = index
      this.parentId = item.id
    },
    change_arro(index,inc){
      this.list[index].child[inc].ishow = (this.list[index].child[inc].ishow + 1) % 2;
    }
  }
};
</script>
<style>
.dict .ivu-btn {
  margin: 10px 0;
}
.dict {
  background-color: white;
  padding: 10px;
}
.dict ul {
  font-size: 16px;
  line-height: 33px;
  background-color: #f0f2f5;
  border-radius: 5px;
  border: 1px solid #cdcdcd;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.19);
  margin-bottom: 10px;
}
.dict .parent:hover {
  background-color: #fff;
}
.dict .parent {
  padding: 5px;
  border-radius: 5px;
}
.dict .child {
  text-align: center;
  background-color: #ed3f14;
  border-color: #ed3f14;
  color: #fff;
  padding: 2px 10px 0 7px;
  font-size: 12px;
  border-radius: 3px;
  line-height: 24px;
  float: right;
  margin: 8px 10px 0 0;
  cursor: pointer;
}
.dict ul li {
  line-height: 38px;
  list-style-type: none;
  border-top: 1px solid #cdcdcd;
  padding-left: 10px;
}
.ivu-menu-opened1 > * > .ivu-menu-submenu-title-icon1{
  -webkit-transform: rotate(180deg);
   transform: rotate(180deg);
}
.ivu-menu-submenu-title-icon1{
  float: right;
  margin: 12px 15px 0 0;
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
    transition: -webkit-transform 0.2s ease-in-out;
    transition: transform 0.2s ease-in-out;
    transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
}
</style>